import script from "./ReleaseNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReleaseNotes.vue?vue&type=script&setup=true&lang=ts"

import "./ReleaseNotes.vue?vue&type=style&index=0&id=b76b66c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76b66c8"]])

export default __exports__